import { Form, Field } from 'react-final-form'
import NumberField from '../utils/NumberField'
import { connect } from 'react-redux'
import { useState } from 'react'
import { partnersRequest } from '../../actions'
const GetInTouch = ({ mobileNav, user, partnersRequest }) => {
    const [formState, setFormState] = useState({loading: false, msg: null})
    const onSubmit = (formValues) => {
        setFormState(state => {
        return {...state, loading: true}
        })
        partnersRequest(formValues, setFormState)
    }
    const initialValue = user.loginStatus ? {name: `${user.first_name} ${user.last_name}`, email: user.email, number: user.number} : {}

    const validateForm = (formValue) => {
        if (formValue.name && formValue.number && formValue.email && formValue.detail){
            let number = formValue.number
            if (number[0].match(/[0-6a-zA-Z+]/)){
                return {number: 'error'}
            }
            else if (number.length !== 10){
                return {number: 'error'}
            }
            else {
                return
            }
        }
        else{
            if (!formValue.name){
                return {name: 'error'}
            }
            else if (!formValue.number){
                return {number: 'error'}
            }
            else if (!formValue.email){
                return {email: 'error'}
            }
            else if (!formValue.detail){
                return {detail: 'error'}
            }
        }
    }
    return (
        <div className="get-in-touch-container ui container">
            <h1>Start earning straight away. Share your details and we will reach out with next steps.</h1>
            <Form 
            onSubmit={onSubmit}
            validate={validateForm}
            initialValues={initialValue}
            render={(formProps) => (
                <form onSubmit={formProps.handleSubmit} className={`ui form partner-form ${mobileNav ? "big" : "huge"}`}>

                        <Field name="name" type="text">
                            {({meta, input}) => (
                                <div className={`field ${meta.touched && meta.error && 'error'}`}>
                                    <input {...input} placeholder="Name"/>
                                </div>
                            )}
                        </Field>

                    <Field name="number" type="text">
                        {({meta, input}) => (
                            <NumberField input={input} meta={meta} style={{background:'hsla(0,0%,100%,.2)'}}/>
                        )}
                    </Field>
                    <Field name="email" type="email">
                        {({meta, input}) => (
                            <div className={`field ${meta.touched && meta.error && 'error'}`}>
                                <input type="text" {...input} placeholder="Email"/>
                            </div>
                        )}
                    </Field>
                    <Field name="detail" type="text">
                        {({meta, input}) => (
                            <div className={`field ${meta.touched && meta.error && 'error'}`}>
                                <input {...input} placeholder="What do you do?" />
                            </div>
                        )}
                    </Field>

                    <button className={`big ui button ${formState.loading ? "loading" : ""}`} type="submit">
                        Get in touch
                    </button>
                </form>
            )}
            />
            {formState.msg && (
                <div className={`ui visible message ${formState.msg?.status === 'error' ? "red" : formState.msg?.status === "ok" ? "blue" : null}`}>
                    <p>{formState?.msg?.message}</p>
                </div>
            )}
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        mobileNav: state.mobileNav,
        user: state.Authentication
    }
}
export default connect(mapStateToProps, { partnersRequest })(GetInTouch)